// E'lon manzili — serverdagi LandingService.rentUrl/partnerUrl bilan bir xil qoida:
//   /ijara/2-xonali-kvartira-yunusobod-37, /xonadosh/xonadosh-chilonzor-12 (oxirgi raqam — id)
// Eski /addinner/37 manzillari server tomonidan 301 bilan shu yerga yo'naltiriladi.

export const slug = (s) => String(s || '').toLowerCase()
  .replace(/['ʻʼ’‘`]/g, '')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

const regionShort = (r) => (r === 'Toshkent shahri' ? 'Toshkent' : r || '');
const placeSlug = (ad) => slug(ad.district ? ad.district.replace(/\s+tumani$/i, '') : regionShort(ad.region));

export function adPath(ad, partner = false) {
  if (!ad || ad.id == null) return '/';
  const place = placeSlug(ad);
  if (partner) return `/xonadosh/xonadosh${place ? `-${place}` : ''}-${ad.id}`;
  const rooms = ad.roomCount > 0 ? `${ad.roomCount}-xonali-` : '';
  const kind = ad.accommodationType === 'YARD' ? 'hovli-uy' : 'kvartira';
  return `/ijara/${rooms}${kind}${place ? `-${place}` : ''}-${ad.id}`;
}

/** /ijara/...-37 yoki /xonadosh/...-12 → { partner, id }; landing bo'lsa null */
export function parseAdPath(pathname) {
  const m = /^\/(ijara|xonadosh)\/(?:[a-z0-9-]+-)?(\d+)\/?$/.exec(pathname || '');
  return m ? { partner: m[1] === 'xonadosh', id: m[2] } : null;
}
